<template>
  <div :class="$style.customConfirmIcon" />
</template>

<style module>
.customConfirmIcon {
    background: var(--color-pacificblue) center no-repeat;
    height: 84px;
    width: 84px;
    border-radius: 100%;
    margin: 0 auto var(--space-md);
    font-weight: 100;
    position: relative;

    &:before {
        font-family: var(--font-family-icomoon);
        content: '\e90f';
        color: var(--color-white);
        font-size: clamp(41px, 2vw, 42px);
        display: inline-block;
        position: absolute;
        left: 21px;
        top: 12px;
    }
}
</style>
